/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsseriesplanscreated3Inputs */

const en_statsseriesplanscreated3 = /** @type {(inputs: Statsseriesplanscreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans created`)
};

const de_statsseriesplanscreated3 = /** @type {(inputs: Statsseriesplanscreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellte Pläne`)
};

/**
* | output |
* | --- |
* | "Plans created" |
*
* @param {Statsseriesplanscreated3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsseriesplanscreated3 = /** @type {((inputs?: Statsseriesplanscreated3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsseriesplanscreated3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsseriesplanscreated3(inputs)
	return de_statsseriesplanscreated3(inputs)
});
export { statsseriesplanscreated3 as "statsSeriesPlansCreated" }